exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js?{"modifyVars":{"@primary-color":"#cc0000","@layout-body-background":"#cc0000","@layout-header-background":"white"}}!./src/styles/index.less
// module id = 1685
// module chunks = 0